<template>
    <div v-if="handleData">
     <h5>  New : <b>{{ handleData.invoiceId }} - {{ handleData.serial_no }}</b></h5>
    </div>
</template>
<style scoped>
h5{
    color: brown;
}
</style>
<script>
export default {
    created() {       
        this.$eventBus.$on('data-sent', (data)=>{
            this.handleData=data
        });     
    },
    data() {
        return {
            handleData:"",
        };
    }, 
    methods: {
    },
};
</script>
